import { createElementVNode as _createElementVNode, unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";

var _withScopeId = function _withScopeId(n) {
  return _pushScopeId("data-v-a9e5c778"), n = n(), _popScopeId(), n;
};

var _hoisted_1 = {
  class: "container max-width"
};

var _hoisted_2 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("h1", null, "大印家谱核心功能", -1);
});

var _hoisted_3 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("h4", null, "你想要的，这里都有", -1);
});

var _hoisted_4 = {
  class: "infos"
};
var _hoisted_5 = {
  class: "gallery"
};
var _hoisted_6 = ["src"];
var _hoisted_7 = {
  class: "desc"
};
import { galleryList } from './galleryList';
export default {
  setup: function setup(__props) {
    return function (_ctx, _cache) {
      var _component_el_col = _resolveComponent("el-col");

      var _component_el_row = _resolveComponent("el-row");

      return _openBlock(), _createElementBlock("div", _hoisted_1, [_hoisted_2, _hoisted_3, _createElementVNode("div", _hoisted_4, [_createVNode(_component_el_row, {
        gutter: 20
      }, {
        default: _withCtx(function () {
          return [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(galleryList), function (item) {
            return _openBlock(), _createBlock(_component_el_col, {
              span: 6,
              key: item.path,
              index: item.path
            }, {
              default: _withCtx(function () {
                return [_createElementVNode("div", _hoisted_5, [_createElementVNode("img", {
                  src: item.imgSrc,
                  alt: ""
                }, null, 8, _hoisted_6), _createElementVNode("div", _hoisted_7, _toDisplayString(item.desc), 1)])];
              }),
              _: 2
            }, 1032, ["index"]);
          }), 128))];
        }),
        _: 1
      })])]);
    };
  }
};